<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <AirportMasterForm
        ref="airportForm"
        v-model="airportFormModel"
        label-width="10em"
        formMode="edit"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-airport-name-set="autocompleteAirportNameSet"
      />
    </template>
    <template #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import AirportMasterForm from '@/components/organisms/dialog/master/AirportMasterForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    AirportMasterForm,
    EditDialogFooter
  },
  mixins: [
    AirportAutocompleteLoader
  ],
  props: {
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportNameSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      airportFormModel: {
        airport_code: undefined,
        start_date: undefined,
        end_date: undefined,
        airport_name: undefined,
        remote_island_type: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterRegisterDialog.mounted')
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()

      // const params = { ...this.airportFormModel }
      // params.user_id = this.$session.get('login-user').userId

      this.$refs.airportForm.validate()
        .then((valid) => {
          return this.$axios.put('/airport', this.airportFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.margeAirportCodeSet(this.airportFormModel.airport_code)
          this.margeAirportNameSet(this.airportFormModel.airport_name)
          this.$emit('refresh')
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['airport_code', 'airport_name']
      this.$nextTick(() => {
        this.$refs.airportForm.clearFields()
        Object.keys(this.airportFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.airportFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
